import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 11",
    id: "SB3-U11-P75-E1",
    audio: "img/FriendsPlus/Page74/Audio/audio-e3-p74.mp3",
    video: "Videos/e3.p74.mp4",
    component: UI,
    recorder: true,
    question: [],
    titleQuestion: [{ color: "#44509f", num: "1", title: 'Listen to the story and repeat. Act.' }],
    questionImage: [
      // Row
      [
        // Column3
        { url: "img/FriendsPlus/Page74/E3/4.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh1-e3-p74.mp3", },
        { url: "img/FriendsPlus/Page74/E3/5.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh2-e3-p74.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page74/E3/6.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh3-e3-p74.mp3", },
        { url: "img/FriendsPlus/Page74/E3/7.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh4-e3-p74.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page74/E3/8.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh5-e3-p74.mp3", },
        { url: "img/FriendsPlus/Page74/E3/9.jpg", audioUrl: "img/FriendsPlus/Page74/Audio/hinh6-e3-p74.mp3", },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 11",
    id: "SB3-U11-P75-E2",
    audio: "img/FriendsPlus/Page75/Audio/audio-e2-p75.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page75/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page75/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page75/Audio/tieude-e2-p75.mp3",
        },
        { url: "img/FriendsPlus/Page75/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page75/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page75/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page75/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page75/Audio/hinh1-e2-p75.mp3",
        },
        {
          url: "img/FriendsPlus/Page75/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page75/Audio/hinh2-e2-p75.mp3",
        },
        {
          url: "img/FriendsPlus/Page75/E2/8.jpg",
        },
      ],
      [{ url: "img/FriendsPlus/Page75/E2/9.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 11",
    id: "SB3-U11-P75-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page75/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    nit: "Unit 11",
    id: "SB3-U11-P75-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page75/E4/Key/answerKey.png",
    inputSize: 200,
    titleImage: '',
    backgroundColor: 'transparent',
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Look and write.' }],
    questionImage: [],
    questions: [
      {
        title: `        
          <div style=" display: flex; flex-direction: row; ">
            <div><img src='img/FriendsPlus/Page75/E4/1.jpg' /></div>
            <div style=" margin: auto 20px ; "><div>The horse is <u style='color: rgb(20,175,235);'>bigger than</u> the goat.</div></div>
          </div>        
          <div style=" display: flex; flex-direction: row; ">
            <div> <img src='img/FriendsPlus/Page75/E4/2.jpg' /> </div>
            <div style=" margin: auto 20px ; ">The girl is # the boy.</div>
          </div>        
          <div style=" display: flex; flex-direction: row; ">
            <div><img src='img/FriendsPlus/Page75/E4/3.jpg' /></div>
            <div style=" margin: auto 20px ; "><div>The boy is # the girl.</div></div>
          </div>        
          <div style=" display: flex; flex-direction: row; ">
            <div><img src='img/FriendsPlus/Page75/E4/4.jpg' /></div>
            <div style=" margin: auto 20px ; ">The sheep is # the cow.</div>
          </div>
        `,
        answer: ['taller than', 'shorter than', 'smaller than'],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 11",
    id: "SB3-U11-P74-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page75/E5/1.jpg" }]],
  },
};

export default json;
